// extracted by mini-css-extract-plugin
module.exports = {"container":"_3vCFwKhaJ5aak0zjWiRhvX","cancelBtn":"_1Ppgr1_8CR1hwgOW4qCtWV","icon":"_2Meta5sHDAQKyPDG8MLm7W","saveBtn":"qLGkEDPHrVpuaUAOlsGFP"};